import React, { Component } from 'react';
import { connect } from 'react-redux';
import Fuse from 'fuse.js';
import _ from 'lodash';
import ReactIScroll from 'react-iscroll';
import iScroll from 'iscroll';

import shared from '../../utils/shared.js'

const ops = {
  shouldSort: true,
  threshold: 0.2,
  location: 0,
  distance: 1000,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  findAllMatches: true,
  keys: ["q1", "q2"],
  id: 'uuid',
}

export class Results extends Component {

  constructor(props) {
    super(props);
    this.state = {
      normalizedData: [],
      initialLocationSet: false,
      query: shared.parseStringParam(this.props.history.location.search, "query")
    }
    this.scrollRef = {};
    this.storyRefs = [];
    this.donorRefs = [];
    this.normalizeSearchData = this.normalizeSearchData.bind(this);
    this.setInitialLocation = this.setInitialLocation.bind(this);
  }

    componentWillMount(){
        shared.checkData(this.props.screen);
    }

  componentDidMount() {
    this.normalizeSearchData();
  }

  componentWillUnmount() {
    for (let i = 0; i < this.storyRefs.length; i++) {
      this.storyRefs[i].removeEventListener("tap", () => this.handleTap(this.storyRefs[i]));

    }
    for (let a = 0; a < this.donorRefs.length; a++) {
      this.donorRefs[a].removeEventListener("tap", () => this.handleTap(this.donorRefs[a]));
    }
  }

  setInitialLocation() {
    if (this.state.initialLocationSet === false) {
      for (let i = 0; i < this.storyRefs.length; i++) {
        this.storyRefs[i].addEventListener("tap", () => this.handleTap(this.storyRefs[i]));

      }
      for (let a = 0; a < this.donorRefs.length; a++) {
        this.donorRefs[a].addEventListener("tap", () => this.handleTap(this.donorRefs[a]));
      }
      this.setState({
        initialLocationSet: true
      })
    }
  }

  //consider caching all this data on start, or delivering from server in this fasion.
  normalizeSearchData() {
    let normalizedData = [];
    let uuid = 0;
    for (var i = 0; i < this.props.donors.donorCategories.length; i++) {
      if (this.props.donors.donorCategories[i].donors.length > 0) {
        for (var a = 0; a < this.props.donors.donorCategories[i].donors.length; a++) {
          normalizedData.push({
            uuid: uuid++,
            q1: this.props.donors.donorCategories[i].donors[a].name,
            q2: "",
            q3: "",
            type: "donor",
            id: this.props.donors.donorCategories[i].donors[a].id,
            ref1: i,
            ref2: a
          });
        }
      }
    }

    for (var b = 0; b < this.props.content.dm_active.length; b++) {
      if (this.props.content.dm_active[b].display_module_type === "Story") {
        normalizedData.push({
          uuid: uuid++,
          q1: this.props.content.dm_active[b].stories[0].name,
          q2: this.props.content.dm_active[b].stories[0].contents.headline,
          q3: this.props.content.dm_active[b].stories[0].contents.story,
          type: "story",
          id: this.props.content.dm_active[b].stories[0].id,
          ref1: b,
          ref2: 0
        });
      }
      if (this.props.content.dm_active[b].display_module_type === "Stories") {
        for (let c = 0; c < this.props.content.dm_active[b].stories.length; c++) {
          if (!_.find(normalizedData, { id: this.props.content.dm_active[b].stories[c].id, type: "story" })) {
            normalizedData.push({
              uuid: uuid++,
              q1: this.props.content.dm_active[b].stories[c].name,
              q2: this.props.content.dm_active[b].stories[c].contents.headline,
              q3: this.props.content.dm_active[b].stories[c].contents.story,
              type: "stories",
              id: this.props.content.dm_active[b].stories[c].id,
              ref1: b,
              ref2: c
            });
          }
        }
        // _.forEach(this.props.content.dm_active[b].stories, (story, index) => {
        //   if (!_.find(normalizedData, { id: story.id, type: "story" })) {
        //     normalizedData.push({
        //       uuid: uuid++,
        //       q1: story.name,
        //       q2: story.contents.headline,
        //       q3: story.contents.story,
        //       type: "stories",
        //       id: story.id,
        //       ref1: b,
        //       ref2: index
        //     });
        //   }
        // })
      }
    }
    this.setState({
      normalizedData: normalizedData
    })
  }

  renderDonorResults(donorResults) {
    return (
      donorResults.map(function (row, i) {
        return (
          <div className={"phand donorlist?activeRef="+ row.activeRef+"&donorid=" + row.donor_id} style={{ fontSize: this.props.screen.r16_9.p10 * .3 }} ref={el => this.donorRefs[i] = el} key={i} >
            {row.dm_name} | {row.name}
          </div>
        )
      }, this)
    )
  }

  renderStoryResults(storyResults) {
    return (
      storyResults.map(function (row, i) {
        return (
          <div id={row.story_id} className={"phand story?selectedModule=" + row.dmActiveRef} ref={el => this.storyRefs[i] = el} key={i} style={{ fontSize: this.props.screen.r16_9.p10 * .3 }}>
            {row.name} | {row.headline}
          </div>
        )
      }, this)
    )
  }

  handleTap(e) {
    let fullClass = String(e.className);
    if (e.className.includes("story")) {
      let selectedModule = shared.parseStringParam(fullClass, "selectedModule");
      //console.log("logging: ", selectedModule, e.id);
      //console.log(this.props.content.dm_active[selectedModule].display_module_type)
      if (this.props.content.dm_active[selectedModule].display_module_type==="Story"){
        this.props.navroute(selectedModule, "Story", "Search", null)
      }
      else if (this.props.content.dm_active[selectedModule].display_module_type==="Stories"){
        for (var i=0; i<this.props.content.dm_active[selectedModule].stories.length; i++){
          if (Number(this.props.content.dm_active[selectedModule].stories[i].id)===Number(e.id)){
            this.props.navroute(selectedModule, "Story", "Stories", {storyIndex: i})
          }
        }

      }
      //SHOULD LIST STORIES MODULE | STORIES, if result is from a stories module... 
      //NEED TO SET NULL TO THE MODULE REF OF THE STORY, OR THE STORIES MODULE IT BELONGS TO?
      //May return id of story, might need to loop through actives for id match, if so set as story
      //If not loop through stories modules module, better would be to pass "stories module id (or null) and then active module idref or stories ref"
            


     // this.props.navroute(selectedModule, Number(e.id), "Story", false);

    }
    if (e.className.includes("donor")) {
      let donorId = shared.parseStringParam(fullClass, "donorid");
      let activeRef = shared.parseStringParam(fullClass, "activeRef");
      let donorlistmodule =this.props.content.dm_active[activeRef];

      if (donorlistmodule !== null) {
        this.props.navroute(activeRef, "Donor List", "Results", {donorId: donorId});
      }

    }
  }

  renderResults() {
    if (this.state.normalizedData.length > 0) {

      let fuse = new Fuse(this.state.normalizedData, ops);
      let results = fuse.search(this.state.query);
      let donorResults = [];
      let storyResults = [];
      let story;
      _.forEach(results, (result) => {
        let rref = _.find(this.state.normalizedData, { uuid: result });
    //TODO: 
    // updating too often, handle dont update
    //    console.log("*********RREF RESULSTS***********");
   //     console.log(rref);
  //      console.log("*********END RESULTS************");
        switch (rref.type) {
          case "donor":
            let donor = this.props.donors.donorCategories[rref.ref1].donors[rref.ref2];
            _.forEach(this.props.content.dm_active, (dm, index) => {
              if (dm.display_module_type === "Donor List" || dm.display_module_type === "Donor Sea") {
                _.forEach(dm.contents.include_categories, (catId) => {
                    if (catId===donor.donor_category){
                      donorResults.push({ dmActiveRef: rref.ref1, name: donor.name, donor_id: donor.id, dm_name: dm.name, activeRef: index });
                    }
                });
              }
            });
            break;
          case "story":
            story = this.props.content.dm_active[rref.ref1].stories[0];
            storyResults.push({ dmActiveRef: rref.ref1, story_id: story.id, name: story.name, headline: story.contents.headline })
            break;
          case "stories":
            story = this.props.content.dm_active[rref.ref1].stories[rref.ref2];
            storyResults.push({ dmActiveRef: rref.ref1, story_id: story.id, name: this.props.content.dm_active[rref.ref1].name+" | "+story.name, headline: story.contents.headline })
            break;
          default:
            break;
        }
      })
      let renderDonors = this.renderDonorResults(donorResults);
      let renderStories = this.renderStoryResults(storyResults);
      return (
        <div>
          <br />
          <div style={{ fontSize: this.props.screen.r16_9.p10 * .6 }}><b>Donors</b></div><br />
          {renderDonors}<br />
          <div style={{ fontSize: this.props.screen.r16_9.p10 * .6 }}><b>Stories</b></div><br />
          {renderStories}
        </div>
      )

    }
    return (<span />);
  }

  render() {

    let results = this.renderResults();
    let u10 = this.props.screen.r16_9.p10

    let headlineText = {
      textAlign: 'vertical',
      display: 'inline-block',
      color: 'black',
      fontSize: this.props.screen.r16_9.p10 * .6,
      lineHeight: String(this.props.screen.r16_9.p10 * .6 * .78) + "px",
      position: 'absolute',
      width: this.props.screen.r16_9.screenWidth
    }

    let leftWidth = this.props.screen.r16_9.left + this.props.screen.r16_9.width / 6;
    let innerRightWidth = this.props.screen.r16_9.width - this.props.screen.r16_9.width / 6
    let rightWidth = this.props.screen.screenWidth - leftWidth;

    return (

      <div style={{ width: '100vw', height: '100vh', position: 'absolute' }}>

        <div style={{ position: 'fixed', top: 0, left: leftWidth, width: rightWidth, height: this.props.screen.screenHeight, backgroundColor: 'white', color: 'black', pointerEvents: 'none' }} />


        <div className="phand" style={{ color: 'black', position: 'fixed', left: leftWidth + u10, top: 0, height: u10 * 2, width: rightWidth, backgroundColor: 'white' }} >
          <div style={{ backgroundColor: 'red', position: 'absolute', top: u10, width: '100%' }}>
            <span style={headlineText}><b>Search Results</b></span>
          </div>
        </div>

        <div style={{ position: 'fixed', top: u10 * 2, left: leftWidth + u10, width: innerRightWidth - u10, height: u10 * 7, color: 'black', pointerEvents: 'auto', touchAction:"none" }}>


            <ReactIScroll ref={el => this.scrollRef[0] = el} iScroll={iScroll}
              options={{
                mouseWheel: true,
                scrollbars: false,
                scrollX: false,
                scrollY: true,
                probeType: 2,
                bounce: false,
                momentum: true,
                deceleration: 0.015,
                useTransition: true,
                disableTouch: false,
                disablePointer: false, 
                disableMouse: false,
                tap: true
                //deceleration: .01
              }}
              onRefresh={this.setInitialLocation}
            >
              <div>
                <div style={{ height: u10 * .5 }} />
                {results}
                <div style={{ height: u10 * 7 }} />
              </div>
            </ReactIScroll>



        </div>

        <div className="topgrad" style={{ position: 'fixed', top: u10 * 2, left: leftWidth + u10, width: innerRightWidth - u10, height: u10 * 1 }} />
        <div className="bottomgrad" style={{ position: 'fixed', top: u10 * 8, left: leftWidth + u10, width: innerRightWidth - u10, height: u10 * 1.1 }} />

        <br style={{ clear: 'both' }} />

      </div>


    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    screen: state.screen,
    donors: state.donors,
    content: state.content
  }
}

export default connect(mapStateToProps, null)(Results);






// WEBPACK FOOTER //
// ./src/Components/Search/Results.js